import pkg from '../package.json';
const version = pkg.version;
export { default as dark } from './theme-dark';
export { default as excel } from './theme-excel';
export { default as fivethirtyeight } from './theme-fivethirtyeight';
export { default as ggplot2 } from './theme-ggplot2';
export { default as latimes } from './theme-latimes';
export { default as quartz } from './theme-quartz';
export { default as vox } from './theme-vox';
export { default as urbaninstitute } from './theme-urbaninstitute';
export { default as googlecharts } from './theme-googlecharts';
export { version };
//# sourceMappingURL=index.js.map